var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"datetime-local","disabled":_vm.$disabled,"readonly":_vm.$readonly,"name":_vm.name},domProps:{"value":_vm.date},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }